module.exports = __webpack_public_path__ + "static/media/zeya_drawing (1).8c1dcd31.svg";